import { useEffect } from 'react';

const useDetectOutsideClicks = (
  onOutsideClick: (e: MouseEvent) => void,
  container: HTMLElement | null,
  extraInsideElements?: HTMLElement[],
) => {
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (!container || !e.target) {
        return;
      }
      const clickTarget = e.target as Node;
      if (container.contains(clickTarget)) {
        return;
      }
      if (
        extraInsideElements &&
        extraInsideElements.find(n => n.contains(clickTarget))
      ) {
        return;
      }

      onOutsideClick(e);
    };

    document.addEventListener('mousedown', handleOutsideClick, false);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  });
};

export { useDetectOutsideClicks };
